/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-10-17 16:58:33
 * @modify date 2023-10-17 16:58:33
 * @desc MyInfo 화면에서 사용되는 데이터 정의
 */


import MyInfoUpdate from "./MyInfoUpdate";
import { DropdownType } from "../../base/CustomDropdown"
import i18n from "../../../lang/base";

export const accountUpdateModalContent = {
    title: i18n.t("ACCOUNT_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <MyInfoUpdate />,
}

export const genderTypes:DropdownType[] = [
    {
        value: "MALE",
        label: i18n.t("MALE_TEXT")
    },
    {
        value: "FMALE",
        label: i18n.t("FEMALE_TEXT")
    },
    {
        value: "NONE",
        label: i18n.t("UNKNOWN_TEXT")
    },
]



export interface MyInfoData {
    alias: string,
    company_name: string,
    create_ts: string,
    current_login_ts: string,
    update_ts: string,
    department_name: string,
    department_rank: string,
    email: string,
    sms_notify_yn: boolean,
    email_notify_yn: boolean,
    first_login_yn: boolean,
    fullname: string,
    last_login_ts: string,
    password_change_ts: string,
    phone_number: string,
    project_role_type_code: string,
    user_id: string,
    user_role_type_code: string,
    user_status_code: string,
    project: {
        project_id: string,
        project_name: string,
        project_description: string,
    }
}


export const initMyInfoData = {
    alias: '',
    company_name: '',
    create_ts: '',
    current_login_ts: '',
    update_ts: '',
    department_name: '',
    department_rank: '',
    email: '',
    sms_notify_yn: true,
    email_notify_yn: true,
    first_login_yn: true,
    fullname: '',
    last_login_ts: '',
    password_change_ts: '',
    phone_number: '',
    project_role_type_code: '',
    user_id: '',
    user_role_type_code: '',
    user_status_code: '',
    project: {
        project_id: '',
        project_name: '',
        project_description: ''
    }
}